import { render, staticRenderFns } from "./chapterFieldEdit.vue?vue&type=template&id=fb5d166c&scoped=true"
import script from "./chapterFieldEdit.vue?vue&type=script&lang=js"
export * from "./chapterFieldEdit.vue?vue&type=script&lang=js"
import style0 from "./chapterFieldEdit.vue?vue&type=style&index=0&id=fb5d166c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5d166c",
  null
  
)

export default component.exports